import { getLoocalizedStrings, IConnectedAppBarProps } from '@microsoft/portal-app/lib/App/ConnectedStandardAppBar';
import { isDialogOpen } from '@microsoft/portal-app/lib/Notifications/isDialogOpen';
import { OptionsActions } from '@microsoft/portal-app/lib/Options/models';
import { createAction } from '@microsoft/portal-app/lib/redux/createAction';
import { IStandardAppBarProps, StandardAppBar } from '@uifabric/portal-ux/lib/StandardAppBar';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { getOfficeTheme } from '../theme';

/**
 * Maps the external (i.e. own) props and the state to the properties of the ConnectedAnonymousHeader control.
 * @param state The current redux state to map to props
 * @param props The external properties to map to props
 * @returns The mapped properties that along with the actions
 * becomes the props (IStandardAppBarProps) for the ConnectedAnonymousHeader control
 */
export const mapStateToProps = (
  state: any,
  props: IConnectedAppBarProps
): IConnectedAppBarProps => {
  return {
    ...getLoocalizedStrings(props.t),
    helpVisible: true,
    isHelpOpen: isDialogOpen(state, OptionsActions.showHelp),
    navVisible: false,
    theme: getOfficeTheme(),
    ...props
  };
};

/**
 * Maps the dispatch actions to the props for the ConnectedAnonymousHeader control.
 * @param dispatch Dispatches actions to the store
 * @returns The mapped actions that along with the mapped properties
 * becomes the props (IStandardAppBarProps) for the ConnectedAnonymousHeader control
 */
export const mapDispatchToProps = (
  dispatch: Dispatch<{}>
): Partial<IStandardAppBarProps> => {
  return {
    onHelpClick: createAction(OptionsActions.showHelp, dispatch),
  };
};

export const ConnectedAnonymousHeader = connect(mapStateToProps, mapDispatchToProps)(StandardAppBar);
